import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AlertsService } from '../../services/utelize/system/alert/alerts-service';
import { AuthenticationService } from '../../services/auth.service';
import { catchError, Observable, throwError } from 'rxjs';
import { ConfigSystemParams, dropdownSelectAllValues } from '../../consts';
import { ConfigSystemService } from '../../services/utelize/system/config-system/config-system-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';
import { IdAndDescriptionDTO } from '../../interfaces/general/id-description';

@Component({
  selector: 'app-dropdown-alert-default-template',
  templateUrl: './dropdown-alert-default-template.component.html',
  styleUrls: ['./dropdown-alert-default-template.component.scss']
})

export class DropdownAlertDefaultTemplateComponent implements AfterViewInit, OnInit {

  @Input() alertGroupId                             : number  | undefined;
  @Input() companyId                                : number  | undefined;
  @Input() initialAlertDefaultTemplateId            : number  | undefined;
  @Input() retainFirstBlankOption                   : boolean | undefined;
  @Input() showLabel                                : boolean = false;
  @Input() userId                                   : number  | undefined;
  
  @Output() selectOnChangeEvent     : EventEmitter<number> = new EventEmitter<number>();

  @ViewChild('alertDefaultTemplateSelect') alertDefaultTemplateSelect!: ElementRef;
    
  get selectAllOption() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DropdownsProvideSelectAllOption, false ); }
  
  private curUserID                     : number;
  private alertDefaultTemplateIdData!   : IdAndDescriptionDTO[];

  public addOrEditForm!                 : UntypedFormGroup;
  public firstAlertDefaultTemplateOption: string="";
  
  constructor(
    private alertsService        : AlertsService,
    private authenticationService: AuthenticationService,
    private configSystemService  : ConfigSystemService,
    private exceptionsService    : ExceptionsService,
    private formBuilder          : FormBuilder
  ) {
    this.curUserID=this.authenticationService.currentUserObject().userId;
  }

  ngOnInit(): void {
    try {
      this.getDropdownData();

      let alertDefaultTemplateId          =this.initialAlertDefaultTemplateId==undefined ? 0 : this.initialAlertDefaultTemplateId;
      this.firstAlertDefaultTemplateOption=!this.retainFirstBlankOption && this.selectAllOption ? dropdownSelectAllValues.AlertDefaultTemplate : "";

      this.addOrEditForm=this.formBuilder.group({
        alertDefaultTemplateID: [alertDefaultTemplateId, []]
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  ngAfterViewInit(){
    try {
      this.selectOnChange(undefined, undefined);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public clearSelection() {
    try {
       this.addOrEditForm.get('alertDefaultTemplateID')?.reset();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }

  public getDropdownDataObjectArray() {
    try {
      return this.alertDefaultTemplateIdData;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }
 
  private getDropdownData() {
    try {
      let dataSource: Observable<IdAndDescriptionDTO[]>;

      dataSource=this.alertsService.getAlertDefaultTemplateIdAndDescription(this.alertGroupId ?? 0);

      dataSource
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.alertDefaultTemplateIdData=(data as IdAndDescriptionDTO[]);
         },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshData() {
    this.getDropdownData();
  }

  public selectOnChange(event: Event | undefined, iccid: string | undefined) {
    try {
      let alertDefaultTemplateID=this.addOrEditForm.controls["alertDefaultTemplateID"].value;

      if (isNaN(alertDefaultTemplateID) || alertDefaultTemplateID=="") {
        alertDefaultTemplateID=-1;
      }
      
      this.selectOnChangeEvent.emit(alertDefaultTemplateID);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }
}
